import React from "react";
import { motion } from "framer-motion";
import { EyeOff, Sparkles, Scale, HourglassIcon } from "lucide-react";

const ITEMS = [
  {
    icon: EyeOff,
    title: "Peur d'être jugé",
    line: "tu sens des regards là où il n'y en a pas.",
  },
  {
    icon: Sparkles,
    title: "Besoin d'être parfait",
    line: "tu repousses jusqu'à ce que ce soit irréprochable. donc jamais.",
  },
  {
    icon: Scale,
    title: "Comparaison permanente",
    line: "tu te mesures à des gens qui n'existent que dans ton fil.",
  },
  {
    icon: HourglassIcon,
    title: "Jamais assez prêt",
    line: "encore une formation. encore une preuve. encore demain.",
  },
];

export default function PainSection() {
  return (
    <section
      data-testid="pain-section"
      id="reconnaissance"
      className="relative py-24 md:py-36 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16 md:mb-24">
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
            01 · Reconnaissance
          </p>
          <h2 className="font-display uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em]">
            Une petite voix{" "}
            <span className="font-serif italic font-light text-gold normal-case lowercase">
              qui décide
            </span>{" "}
            à ta place.
          </h2>
          <p className="mt-8 font-serif italic text-xl md:text-2xl text-ink-100/80 max-w-2xl lowercase">
            tu as déjà appris. déjà compris. déjà travaillé sur toi. et
            pourtant, au moment d'oser —
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {ITEMS.map((item, idx) => (
            <motion.div
              key={item.title}
              data-testid={`pain-tile-${idx}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.7,
                delay: idx * 0.08,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="group relative bg-obsidian-surface border border-white/[0.06] rounded-2xl p-8 md:p-10 hover:border-gold/40 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="flex items-start gap-6">
                <div className="shrink-0 w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center bg-gold/5">
                  <item.icon className="w-5 h-5 text-gold" />
                </div>
                <div>
                  <h3 className="font-display text-2xl md:text-3xl text-ink-50 mb-3 tracking-tight">
                    {item.title}
                  </h3>
                  <p className="font-serif italic text-ink-400 text-lg lowercase">
                    {item.line}
                  </p>
                </div>
              </div>
              <span className="absolute top-6 right-7 font-display text-xs tracking-[0.25em] text-ink-400/60">
                0{idx + 1}
              </span>
            </motion.div>
          ))}
        </div>

        <div className="mt-20 md:mt-28 max-w-3xl">
          <p className="font-display text-2xl md:text-4xl leading-tight text-ink-100">
            Pendant que tu attends d'être irréprochable…{" "}
            <span className="text-gold font-serif italic font-light">
              ta place reste vide.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}
